import { InjectionToken } from '@angular/core';

// export declare const APIKEY: InjectionToken<string>;
export const APIKEY = new InjectionToken<string>('Api-Key');
export const ASSETSFOLDER = new InjectionToken<string>('Assets-Folder');
